module.exports = __webpack_public_path__ + "media/icons/favourite-off@2x-93e96098.png";